import { useState, useEffect, useCallback } from "react";
import { getCannedResponses, postCannedResponse } from "@/api/cannedResponsesApi";
import { isHumanAgentInboxLive } from "@/api/inboxAgentApi";

/**
 * Loads and creates saved replies via the API layer (skeleton stubs today).
 * @param {{ tenantId?: string, workspaceId?: string }} [scope] Forwarded to list/create when backend exists.
 */
export function useCannedResponses(scope = {}) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    if (isHumanAgentInboxLive() && (!scope.workspaceId || !String(scope.workspaceId).trim())) {
      setItems([]);
      setError(null);
      setLoading(false);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const { data } = await getCannedResponses(scope);
      setItems(data);
    } catch (e) {
      setError(e instanceof Error ? e : new Error(String(e)));
      setItems([]);
    } finally {
      setLoading(false);
    }
  }, [scope]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const createCannedResponse = useCallback(
    async (payload) => {
      if (isHumanAgentInboxLive() && (!scope.workspaceId || !String(scope.workspaceId).trim())) {
        throw new Error("Select a workspace to create saved replies.");
      }
      const { data } = await postCannedResponse({ ...payload, workspaceId: scope.workspaceId });
      setItems((prev) => [...prev, data]);
      return data;
    },
    [scope.workspaceId]
  );

  return { items, loading, error, refresh, createCannedResponse };
}
